import React from 'react';
import { Button } from 'ra-ui-materialui';
import { Check as CheckIcon } from '@material-ui/icons';
import '../../styles.css';

export default ({
  dataProvider,
  resource,
  data,
  setSubmitting,
}) => {
  const handleClick = async () => {
    setSubmitting(true);
    dataProvider('APPROVE_ONE', resource, { id: data.id }, {
      onSuccess: {
        notification: { body: 'Account Approved Successfully!', level: 'info' },
        callback: () => setSubmitting(false),
        refresh: true,
      },
      onError: {
        notification: { body: 'Account Could Not Be Approved!', level: 'warning' },
        callback: () => setSubmitting(false),
      },
    });
  };
  return (
    <Button
      variant="contained"
      label="Approve Account"
      style={{ width: '100%', marginTop: 4 }}
      className="successButton userActionButton"
      onClick={handleClick}
    >
      <CheckIcon />
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/components/User/actions/actions/ApproveAccountButton.jsx